import styled from "styled-components";
import { FlexDiv } from "@/components/Atoms/Box";
import Image from "@/components/Atoms/Image";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import TwoColumnModal from "@/components/Organisms/TwoColumnSection";
import Typography from "@/foundation/Typography/V2";

export const StyledTwoColumnModal = styled(TwoColumnModal)`
  background-color: transparent;
  padding: 0;
  border: none;
  border-radius: 0;
  box-shadow: none;
  @media only screen and (max-width: 1079px) {
    border-radius: 24px 24px 0 0;
    padding: 0;
  }
  .left-section {
    padding: 0;
    flex: 1;
    max-width: 100%;
  }
  .right-section {
    max-width: 100%;
    width: 100%;
    padding: 0;
    @media only screen and (max-width: 1079px) {
      max-width: 100%;
      > div {
        border-radius: 0;
      }
    }
  }
`;
export const InnerColumn = styled(FlexDiv)`
  padding: 56px;
  position: relative;
  background-color: ${({ theme }) => theme.colorsV2.blueGray.shade_50};
  border-radius: 8px;
  @media only screen and (max-width: 1079px) {
    padding: 32px 16px 24px;
    background-color: transparent;
    border-radius: 0;
  }
`;
export const Title = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_800};
  flex: 1;
  @media only screen and (max-width: 767px) {
    padding-right: 24px;
  }
`;
export const TitleImage = styled(FlexDiv)`
  margin: 0px 0 56px;
  flex-direction: column;
  @media only screen and (max-width: 767px) {
    margin: 0px 0 16px;
    flex-direction: row-reverse;
    align-items: center;
  }
`;
export const Subtitle = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_700};
`;
export const ContactUsSection = styled(FlexDiv)`
  margin-top: 48px;
  flex-direction: column;
  @media only screen and (max-width: 767px) {
    margin-top: 8px;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;
export const ContactIcon = styled(StyledSvgSprite)`
  height: 32px;
  width: 32px;
  fill: ${({ theme }) => theme.colorsV2.gray.shade_700};
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
`;
export const PhoneIcon = styled(ContactIcon)`
  height: 32px;
  width: 32px;
  fill: none;
  stroke: ${({ theme }) => theme.colorsV2.gray.shade_700};
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
`;
export const ContactBlock = styled(FlexDiv)`
  position: relative;
  padding-left: 48px;
  margin-bottom: 8px;
  margin-top: 8px;
  align-items: flex-start;
  flex-direction: column;
  margin-right: 40px;
  &:last-child {
    margin-right: 0;
  }
  @media only screen and (max-width: 424px) {
    margin-right: 16px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
export const ContactHeading = styled(Typography)`
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 8px;
`;
export const ContactValue = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.blueGray.shade_800};
`;
export const ContactLink = styled(Typography)``;
export const LHSSection = styled(FlexDiv)``;
export const ImageHolder = styled(Image)``;
export const ImageDiv = styled(FlexDiv)`
  margin-bottom: 12px;
  @media only screen and (max-width: 767px) {
    margin-bottom: 0;
  }
`;
export const ImageBox = styled(FlexDiv)`
  max-height: 48px;
  max-width: 150px;
`;

export const FormFieldBox = styled(FlexDiv)`
  flex-direction: column;
  padding: ${({ padding }) => padding};
  flex: 1;
  @media only screen and (max-width: 1079px) {
    padding: ${({ mobilePadding }) => mobilePadding};
  }
`;
export const StyledFormFieldBox = styled(FormFieldBox)`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 32px 48px;
  @media only screen and (max-width: 1079px) {
    padding: 24px 16px;
  }
  @media only screen and (max-width: 1079px) {
    box-shadow: none;
  }
`;
